import React from "react";
import store from "store";
import $ from "jquery";
import { notify } from "react-notify-toast";
import Page from "../Page";
import { BASE_URL, API_PROFILE, API_PROFILE_BASE_URL } from "../Util";
import FormRegister from "./../Auth/components/Register";
import { Link } from "react-router-dom";

class FormProfile extends Page {
  constructor(props) {
    super(props);
    this.state = {
      type: "smile",
      username_smile: "",
      dataRegister: {},
      params: {},
      payload: {},
    };

    this.clientToken = "aa6d8694eea3d1b52aa6e4169b0a822665b56fc4";
  }

  componentDidMount() {
    this.handleLoadData();
    $(".modal-overlay").trigger("click");
  }

  handleLoadData() {
    // this.setState({ payload: store.get("userdata") });
    $.getJSON(API_PROFILE_BASE_URL).then((data) => {
      this.setState({ payload: data.payload });
    });
  }

  handleSubmit = (e, dataRegister, forceSubmit) => {
    $.post(API_PROFILE_BASE_URL, dataRegister)
      .then((data) => {
        if (data.success) {
          let userData = store.get("userdata");
          let newData = {
            ...userData,
            ...dataRegister,
            nama: dataRegister.name,
            completed_profile: true,
          };
          store.set("userdata", newData);
          notify.show("Berhasil update profile.", "success");
        } else {
          notify.show("Terdapat kesalahan, silakan coba lagi", "warning");
        }
      })
      .fail((XMLHttpRequest, textStatus, errorThrown) => {
        let response;

        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (e) {}

        if (response && response.status) {
          if (response.errors) {
            notify.show(response.errors.email[0], "warning");
          } else {
            notify.show(response.message, "warning");
          }
        }
      });
  };

  render() {
    const { type, payload } = this.state;
    return (
      <div className="pt-m pb-l">
        <div className="form-profile">
          <div>
            <button
              className="btn-link"
              style={{ display: "flex", alignItems: "center" }}
              onClick={(e) => this.props.history.goBack()}
            >
              <i className="material-icons">chevron_left</i>
              <span style={{ padding: "4px" }}>Kembali</span>
            </button>
          </div>
          <div className="mb-s" style={{ marginTop: "32px" }}>
            <div className="font-largest font-heavy mt-0 mb-xss">
              Ubah Profile
            </div>
          </div>

          <FormRegister
            data={payload}
            formType="profile"
            type={payload.smile_id ? "smile" : "email"}
            onSubmit={this.handleSubmit}
            submitButton={
              <div style={{ textAlign: "right", marginTop: "32px" }}>
                <button className="btn mb-s">Ubah Profile</button>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}

export default FormProfile;



// WEBPACK FOOTER //
// ./src/components/User/FormProfile.js